

export const ADDWOMENPRODREQUST = "ADDWOMENPRODREQUST"
export const ADDWOMENPRODSUCCESS= "ADDWOMENPRODSUCCESS"
export const ADDWOMENPRODFAILURE ="ADDWOMENPRODFAILURE"


export const DELETEWOMENPRODREQUST = "DELETEWOMENPRODREQUST"
export const DELETEWOMENPRODSUCCESS= "DELETEWOMENPRODSUCCESS"
export const DELETEWOMENPRODFAILURE ="DELETEWOMENPRODFAILURE"


export const ADDWOMENAMOUNTREQUST = "ADDWOMENAMOUNTREQUST"
export const ADDWOMENAMOUNTSUCCESS= "ADDWOMENAMOUNTSUCCESS"
export const ADDWOMENAMOUNTFAILURE ="ADDWOMENAMOUNTFAILURE"



export const REDUCEWOMENAMOUNTREQUST = "REDUCEWOMENAMOUNTREQUST"
export const REDUCEWOMENAMOUNTSUCCESS= "REDUCEWOMENAMOUNTSUCCESS"
export const REDUCEWOMENAMOUNTFAILURE ="REDUCEWOMENAMOUNTFAILURE"